import type { Config } from "tailwindcss";
import defaultTheme from "tailwindcss/defaultTheme.js";

export default {
	theme: {
		extend: {
			fontFamily: {
				inter: ["inter", ...defaultTheme.fontFamily.sans],
				outfit: ["outfit"],
			},
			fontSize: {
				xs: ["0.75rem", "1"],
				sm: ["0.875rem", "1"],
				base: ["1rem", "1.15"],
				md: ["1.25rem", "1.15"],
				lg: ["1.5rem", "1.15"],
				xl: ["2rem", "1.15"],
				"2xl": ["clamp(2.75rem, 5vw, 3.5rem)", "1.15"],
			},
			colors: {
				green: {
					DEFAULT: "#98CE00",
					animation: "#BEF525",
				},
				black: "#202831",
				lightblue: "#59B2F4",
				light: "#E8F6FF",
				lightwhite: "#ECF7FE",
				blue: {
					DEFAULT: "#005FAA",
					animation: "#59B2F4",
				},
				grey: {
					100: "#F3F5F7",
					200: "#DAE0E7",
					300: "#C1CBD7",
					400: "#A9B7C7",
					500: "#77899C",
				},
			},
		},
	},
} satisfies Partial<Config>;
